/**
 * カンマ区切りの正解データをパースするユーティリティ
 * 引用符で囲まれた部分（カンマを含む）を正しく処理する
 * 
 * 例:
 *   parse('"No, I\'m not."') => ["No, I'm not."]
 *   parse('Yes, No') => ['Yes', 'No']
 *   parse('""▶ ""') => ['"▶ "']
 */
export class CsvAnswerParser {
  static parse(body: string | null | undefined): string[] {
    if (!body || body.trim() === '') {
      return []
    }

    // 引用符で囲まれた部分をマーカーに置換
    const markerPrefix = '__QUOTED_'
    const markerSuffix = '__'
    const quotedParts: string[] = []

    let processed = body.replace(/"([^"]*)"/g, (match, content) => {
      // 空の引用符 "" は " として扱う
      quotedParts.push(content === '' ? '"' : content)
      return `${markerPrefix}${quotedParts.length - 1}${markerSuffix}`
    })

    // カンマで分割してマーカーを復元
    return processed.split(',').map((part) => {
      let trimmed = part.trim()
      // マーカーを順番に復元
      quotedParts.forEach((value, idx) => {
        trimmed = trimmed.replace(`${markerPrefix}${idx}${markerSuffix}`, value)
      })
      // 引用符で囲まれていない "" を " に変換
      return trimmed.replace(/""/g, '"')
    }).filter(s => s !== '')
  }
}
